import * as React from 'react'

import { useRecoilValue } from 'recoil'
import useSWR from 'swr'

import URI from '../../../misc/classes/URI'
import fillUrlWithValues from '../../../misc/helpers/fillUrlWithValues'
import background from '../../../misc/images/backgrounds/background_05.jpg'
import { IInvestmentsResponse } from '../../../models/Invests'
import routes from '../../../router/routes'
import { locale } from '../../../state/locale/atoms/locale'
import { translate } from '../../../state/locale/selectors/translate'
import { Flex } from '../../_layout/Flex'
import { ImageSection } from '../../_layout/ImageSection'
import PageWrapper from '../../_layout/PageWrapper'
import { Breadcrumbs } from '../../reusable/Breadcrumbs'
import { HorizontalCard } from '../../reusable/HorizontalCard'
import { Loading } from '../../reusable/Loading'

const InvestmentsPage = () => {
  const { investments: i18n } = useRecoilValue(translate)
  const breadcrumbs = [
    {
      link: routes.investments,
      title: i18n.breadcrumb,
    },
  ]
  const lang = useRecoilValue(locale)
  const { data, isValidating } = useSWR<IInvestmentsResponse>(URI.getInvestmentsUri(lang))

  return (
    <>
      <ImageSection id={'investments'} image={background} top={true} />
      <PageWrapper>
        <Breadcrumbs base={breadcrumbs} />
        {isValidating && <Loading />}
        <Flex gap={4}>
          {data?.data.map((invest) => (
            <HorizontalCard
              description={
                invest.content[0].children[0].type === 'text' ? invest.content[0].children[0].text : ''
              }
              link={fillUrlWithValues(routes.investment, ':slug', invest.slug)}
              image={invest.images[0]?.provider_metadata.public_id}
              title={invest.title}
              linkText={i18n.page.button}
              key={invest.slug}
            />
          ))}
        </Flex>
      </PageWrapper>
    </>
  )
}

export default InvestmentsPage
